export default __webpack_public_path__ + "static/media/circle-checked.1f559de0.svg";